<div class="fresh-ui">
    <section class="category-intro">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-auto">
                    <h1
                        class="site-title text-500 general_sans text-center">247Invites
                        Categories</h1>
                    <h5 class="sub-heading text-center mb-5 general_sans">
                        Discover Your Perfect Invitations with Our Invitation
                        Card Maker Platform
                    </h5>
                    <p class="general_sans text-center mt-4">
                        Dive into our Invitation Crafter categories on
                        247Invites and uncover a plethora of creative
                        designs. From
                        charming housewarming invitations to elegant wedding
                        card themes, delightful birthday invites to
                        charming
                        baby shower designs, our platform has it all. Elevate
                        your event with captivating online wedding
                        invitation
                        videos that encapsulate the spirit of your celebration.
                        Start crafting your perfect invitation
                        today with
                        247Invites!
                    </p>
                </div>
            </div>
        </div>
    </section>
    <section class="primary-categories mater-categories-cards pt-5">
        <div class="container">
            <div
                class="row justify-content-md-start justify-content-center align-items-start">
                <div class="col-6 col-md-3 col-lg-3"
                    *ngFor="let videoSubCategoryDataItem of subCategory">
                    <div class="cate-card">
                        <a [routerLink]="
                        '/'  + videoSubCategoryDataItem.SubCategorySlug
                      ">
                            <img
                                src="{{ assetURL }}/{{videoSubCategoryDataItem?.SubCategoryImage}}" alt="247Invites">
                            <div class="card-heading pt-3 pb-2 text-center">
                                <span
                                    class="card-head text-center mb-0">{{videoSubCategoryDataItem?.SubCategoryName}}</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>